import ModelService from '@/services/model.service';
import { getField, updateField } from 'vuex-map-fields';
import Constants from '../../constants/Constants';
import ImageService from "@/services/image.service"
import i18n from '@/locales/i18n';

const SET_MODELS = 'SET_MODELS';
const SET_MODEL = 'SET_MODEL';
const RESET = 'RESET';
const FIRST_IDX = 0;

export default {
	namespaced: true,
	state() {
		return {
			models: [],
			model: null,
		};
	},
	actions: {
		/**
		 * Retrieve model list from the server
		 * @param {*} param0
		 * @param {Object} payload: username of the user
		 */
		async retrieveModels({ commit }, payload) {
			let response = await ModelService.retrieveModelList({
				user: payload.username,
      });
      let db_models = response.data.db_models;
      let s3BucketUrl = process.env.VUE_APP_S3_BUCKET_URL;
			let cdnCloudFormation = Constants.CDN_CLOUD_FORMATION.thumbnailImage;
			db_models = db_models.filter((item) => item.train_able === true);

			for await (let model of db_models) {
				let description = model.description
        // Check if the model is shared or not shared
        if (description.includes("--- Shared by")) {
          // Retrieve index of "--- Shared by" in description
          let startIndexSubDescription = description.indexOf("--- Shared by");
          // Get content string from "--- Shared by" to end
          let subDescription = description.slice(startIndexSubDescription);
          // Separate description(description of model) and subDescription(sharers)
          model.subDescription = subDescription
          model.description = description.slice(0, startIndexSubDescription);
        }

				if (model.raw === undefined || model.result === undefined) {
          continue;
				}
				
				let image_name = model.raw.split("/")
        response = await ImageService.getPresignedUrl({
          file_name: image_name.slice(-1)[0],
          s3_key: model.raw,
        });
        let cdnRawImage = response.data.link.replace(s3BucketUrl, cdnCloudFormation)
				model.raw = cdnRawImage
				
				image_name = model.result.split("/")
        response = await ImageService.getPresignedUrl({
          file_name: image_name.slice(-1)[0],
          s3_key: model.result,
        });
        let cdnResultImage = response.data.link.replace(s3BucketUrl, cdnCloudFormation)
        model.result = cdnResultImage
			}

      const fistModel = db_models[FIRST_IDX]?.model_name;
      commit(SET_MODELS, db_models);
      commit(SET_MODEL, fistModel);
		},

		async deleteModel({ commit }, payload) {
			await ModelService.delete(payload);
		
		},

		/**
		 * Set selected model
		 * @param {*} param0
		 * @param {Object} payload: selected model
		 */
		setModel({ commit }, payload) {
			console.log('selected model: ', payload);
			commit(SET_MODEL, payload.model);
		},

		resetTrainerModels({ commit }) {
			commit(RESET);
		},
	},

	mutations: {
		updateField,

		SET_MODEL(state, payload) {
			state.model = payload;
		},

		SET_MODELS(state, payload) {
			state.models = payload;
		},

		RESET(state) {
			state.model = null;
			state.models = [];
		},
	},

	getters: {
		getField,
	},
};
